
export const defaultRangeData = [
    { text: "Use the ",
      code: ".slider " 
    },
    { text: "class. and edmin used Io range slider." 
    }
];
